import { useLocation } from '@reach/router';
import { useState } from 'react';
import { getLanguageName } from '../utils/constants';

export const LOCALES = ['en', 'de', 'es'];

export const useLocale = (node_locale) => {
  const location = useLocation();
  let pathLocale = location?.pathname.split('/').filter((_) => _.length)[0];

  const languageToggleOptions = LOCALES.map((loc) => ({
    label: getLanguageName(loc),
    url: location.pathname?.replace(/^\/([a-z]{2})/, `/${loc}`),
    locale: loc,
  }));

  // static pages are created without the locale part in their path
  if (!LOCALES.includes(pathLocale)) {
    pathLocale = 'en';
  }

  const [locale, setLocale] = useState(() => {
    if (node_locale) return node_locale;

    return pathLocale ?? 'en';
  });

  if (pathLocale !== locale) {
    setLocale(pathLocale);
  }

  return { locale, setLocale, languageToggleOptions };
};
